import { useBusinessOrganizationPricingConfig } from '@sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useGeneratedGetPricingHubRecentPriceChangesQuery } from '@sales-portal/domain/pricing/screens/overview/blocs/documents/pricing-hub-recent-price-changes.generated';
import { useMemo } from 'react';

export const usePricingHubRecentPriceChangesLoader = () => {
  const { hasPricingAccess } = useBusinessOrganizationPricingConfig();

  const { data, error, loading, refetch } =
    useGeneratedGetPricingHubRecentPriceChangesQuery({
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      skip: !hasPricingAccess,
    });

  return useMemo(
    () => ({
      error,
      isLoading: loading && !data,
      recentChanges: data?.getPricingHubRecentPriceChanges,
      refetch,
    }),
    [data, error, loading, refetch],
  );
};
